'use strict';

import $ from 'jquery';
import 'handlers/init';
import 'handlers/embed';

$.ajaxSetup({
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
});

export default class BaseApp
{}



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./assets/scripts/viewmodels/pc/BaseApp.babel.js
 **/